import { Numerical } from "./Numerical";
export class WrappedDecimal extends Numerical {
    constructor(wrapped) {
        super();
        this.wrapped = wrapped;
    }
    getRaw() {
        return this.getWrapped().getRaw();
    }
    getWrapped() {
        return this.wrapped;
    }
    replaceWithValue(value) {
        return this.wrap(this.getWrapped().replaceWithValue(value));
    }
}
//# sourceMappingURL=WrappedDecimal.js.map